import React from 'react'

var interval = 0;

const onSearch = (search) => {
  if(interval) clearTimeout(interval);
   interval = setTimeout(() => {
     search();
   }, 1000)
}

const CheckboxField = ({field, validate, search, checked, clear}) => {
  if(clear){
    field.value = false;
  }
  return (
    <div className="form-group">
      <label className="custom-control custom-checkbox">
        <input
          name={field.name}
          type="checkbox"
          className="custom-control-input"
          //defaultChecked={field.defaultCheckedValue===true}
          checked={field.value === true}
          onChange={e => {
            let newValue = !field.value;
            validate(newValue, field);
            onSearch(search);
          }}
        />
        <span className="custom-control-indicator" />
        <span className="custom-control-description">{field.rules.title}</span>
      </label>
    </div>
  )
}

export default (CheckboxField)
